module.exports = "/_next/static/images/Hero@2x-536835935e0a40295bfcc7e554601254.png";